import { call, put, takeLatest, takeEvery, select } from "redux-saga/effects";
import { callApi, callApiWithNoAuth, callApiWithNoAuthAPi, Method } from "../../api/Api";
import {
  stopLoading,
  showErrorMessage,
  startLoading,
} from "../layout/action";

import {
  GET_CHECKOUT_SELECT_ADDRESS_STATES,
  GET_CHECKOUT_SELECT_PHONE_STATES,
  GET_CHECKOUT_SELECT_EMAIL_STATES,
  GET_BUY_PERMIT_ORDER_PAYMENT,
  setCheckoutSelectAddressStates,
  setCheckoutSelectPhoneStates,
  setCheckoutSelectEmailStates,
  setBuyPermitOrderPayment,
  showBuyPermitThankYouModal,
  emptyBuyPermitCart,
  setBuyPermitPaymentMethods,
  GET_BUY_PERMIT_PAYMENT_METHODS,
  GET_BUY_PERMIT_PERMIT_NUMBER,
  setBuyPermitGetPermitNumber,
  getBuyPermitGetPermitNumber,
  GET_BUY_CREDIT_CARD_VERIFICATION,
  setBuyCheckCreditCradDetails,
  setTaxRateOrder,
  GET_TAX_RATE_VERIFICATION,
  setupdateBuyPermitVehicleList,
  GET_UPDATE_BUY_PERMIT_VEHICLE_LIST,
  RESUME_BUY_PERMIT_ORDER_PAYMENT,
} from "./action";
import { getDriverViewOrderStates } from "../vieworder/action";
import {RouteService} from "../../services/route.service";

export function* callCheckoutAddressModalDetails(action) {
  try {
    yield put(startLoading());
    const stateResponse = yield call(callApi, {
      method: "GET",
      // url: `/eua/${action.payload}`
      url: `/eua/${action.payload.accountId}/address`,
    });

    const { data } = stateResponse;

    yield put(setCheckoutSelectAddressStates(data));
    yield put(stopLoading());
  } catch (err) {
    yield put(stopLoading());
    yield put(
      showErrorMessage({ error: err, title: "Get Chekout Address Modal Data" })
    );
  }
}

export function* watchcallCheckoutAddressModalDetails() {
  yield takeEvery(
    GET_CHECKOUT_SELECT_ADDRESS_STATES,
    callCheckoutAddressModalDetails
  );
}

export function* callCheckoutPhoneModalDetails(action) {
  try {
    yield put(startLoading());
    const stateResponse = yield call(callApi, {
      method: "GET",
      // url: `/eua/${action.payload}`
      url: `/eua/${action.payload.accountId}/phone`,
    });

    const { data } = stateResponse;

    yield put(setCheckoutSelectPhoneStates(data));
    yield put(stopLoading());
  } catch (err) {
    yield put(stopLoading());
    yield put(
      showErrorMessage({ error: err, title: "Get Chekout Phone Modal Data" })
    );
  }
}

export function* watchcallCheckoutPhoneModalDetails() {
  yield takeEvery(
    GET_CHECKOUT_SELECT_PHONE_STATES,
    callCheckoutPhoneModalDetails
  );
}

export function* callCheckoutEmailModalDetails(action) {
  try {
    yield put(startLoading());
    const stateResponse = yield call(callApi, {
      method: "GET",
      // url: `/eua/${action.payload}`
      url: `/eua/${action.payload.accountId}/email`,
    });

    const { data } = stateResponse;

    yield put(setCheckoutSelectEmailStates(data));
    yield put(stopLoading());
  } catch (err) {
    yield put(stopLoading());
    yield put(
      showErrorMessage({ error: err, title: "Get Chekout Email Modal Data" })
    );
  }
}

export function* watchcallCheckoutEmailModalDetails() {
  yield takeEvery(
    GET_CHECKOUT_SELECT_EMAIL_STATES,
    callCheckoutEmailModalDetails
  );
}

/////////////////////////////BUY PERMIT PAYMENT API/////////////////////////////
export function* callBuyPermitOrderPayment(action) {
  try {
    yield put(startLoading());
    const store = yield select();
    const customerName = store.homeState?.customerName;
    let paymentUrl = "";
    const dataPayload = action?.payload;

    const permitFee = dataPayload?.permitsToPurchase[0]?.fee
    const permitPrice = dataPayload?.permitsToPurchase[0]?.price
    const paymentMethod = dataPayload?.paymentRequest?.paymentMethod;

    const isOfflineOrZeroPayment =
      (permitFee <= 0 && permitPrice <= 0) ||
      ["NO_CHARGE", "DRIVER_ACCOUNT", "CASH", "OTHER", "CHECK", "PAYROLL_DEDUCTION"].includes(paymentMethod);

    if (isOfflineOrZeroPayment) {
      paymentUrl = "/orders/portal";
    } else if (paymentMethod === "ONLINE_CC" || paymentMethod.value === "ONLINE_CC" ) {
      paymentUrl = "/orders/portal/order";
    } else if (paymentMethod === "TRANSACT_PAYMENTS") {
      delete dataPayload.paymentRequest;
      paymentUrl = "/orders/external";
    }

    const res = yield call(callApi, {
      data:  dataPayload,
      method: Method.POST,
      url: paymentUrl,
    });

    if (paymentMethod === "TRANSACT_PAYMENTS") {
      const { order, redirectDetails } = res.data;
      yield call(handleExternalRedirect, order, redirectDetails, customerName);
    } else {
      yield put(setBuyPermitOrderPayment(res.data));
      yield put(getBuyPermitGetPermitNumber(res?.data?.id));
      yield put(showBuyPermitThankYouModal());
    }

    yield put(emptyBuyPermitCart());
  } catch (err) {
    yield put(
      showErrorMessage({ error: err, title: "Buy Permit Order Payment" })
    );
  } finally {
    yield put(stopLoading());
  }
}

export function* watchcallBuyPermitOrderPayment() {
  yield takeEvery(GET_BUY_PERMIT_ORDER_PAYMENT, callBuyPermitOrderPayment);
}

///////////////////////BUY PERMIT PAYMENT METHOD///////////////////

export function* callBuyPermitPaymentMethods(action) {
  try {
    yield put(startLoading());
    const stateResponse = yield call(callApi, {
      data: action.payload,
      method: Method.POST,
      url: `/driversaccount/rules`,
    });

    yield put(setBuyPermitPaymentMethods(stateResponse.data));
    yield put(stopLoading());
  } catch (err) {
    yield put(stopLoading());
    yield put(
      showErrorMessage({ error: err, title: "Get Buyer Access Rules" })
    );
  }
}

export function* watchCallBuyPermitPaymentMethods() {
  yield takeEvery(GET_BUY_PERMIT_PAYMENT_METHODS, callBuyPermitPaymentMethods);
}

////////////// BUY PERMIT GET PERMIT NUMBER ////////////////// 

export function* callBuyPermitPermitNumber(action) {
  try {
    yield put(startLoading());
    const stateResponse = yield call(callApi, {
      method: "GET",
      url: `/orders/${action.payload}`
    });

    const { data } = stateResponse;
    yield put(setBuyPermitGetPermitNumber(data));
    yield put(setBuyPermitOrderPayment(data));
    yield put(stopLoading());
  } catch (err) {
    yield put(stopLoading());
    yield put(
      showErrorMessage({ error: err, title: "Get Buyer Access Rules" })
    );
  }
}

export function* watchCallBuyPermitGetPermitNumber() {
  yield takeEvery(GET_BUY_PERMIT_PERMIT_NUMBER, callBuyPermitPermitNumber);
}



//  Credit Card Verification API 
export function* callBuyCreateCardVerification(action) {
  try {
    yield put(startLoading());
    const stateResponse = yield call(callApiWithNoAuth, {
      method: "GET",
      // url: `/clients/check-merchant-account-for-payment/${action.payload}`
      url: `/portal/pages/home-without-session/check-merchant-account-for-payment/${action.payload}`
    });
    const { data } = stateResponse;
    yield put(setBuyCheckCreditCradDetails(data));
    yield put(stopLoading());
  } catch (err) {
    yield put(stopLoading());
    yield put(setBuyCheckCreditCradDetails(err?.data));
    // yield put(
    //   showErrorMessage({ error: err, title: "Credit Card Verification" })
    // );
  }
}

export function* watchCallCreateCardVerification() {
  yield takeEvery(GET_BUY_CREDIT_CARD_VERIFICATION, callBuyCreateCardVerification);
}


// tax verification API
export function* callBuyTaxVerification(action) {
  try {
    yield put(startLoading());
    const stateResponse = yield call(callApiWithNoAuth, {
      method: "GET",
      // url: `/portal/pages/home-without-session/tax-rate/${action.payload}`
      // url: `/clients/tax-rate/${action.payload}`
      url: `/portal/pages/home-without-session/tax-rate/${action.payload}` 
    });
    const { data } = stateResponse;
    yield put(setTaxRateOrder(data));
    yield put(stopLoading());
  } catch (err) {
    yield put(stopLoading());
    // yield put(setTaxRateOrder(err?.data));
    // yield put(
    //   showErrorMessage({ error: err, title: "Credit Card Verification" })
    // );
  }
}

export function* watchCallTaxRateVerification() {
  yield takeEvery(GET_TAX_RATE_VERIFICATION, callBuyTaxVerification);
}


// update Vehicle List in permit

export function* callBuyUpdateVehicleListPermit(action) {
  try {
    yield put(startLoading());
    const stateResponse = yield call(callApi, {
      data: action.payload,
      method: Method.POST,
      url: `/fulfillment-actions/update-fulfillment-vehicles`,
    });

    yield put(setupdateBuyPermitVehicleList(stateResponse.data));
    const EuaID = stateResponse?.data
    yield put (getDriverViewOrderStates(EuaID?.account?.id))
    yield put(stopLoading());
  } catch (err) {
    yield put(stopLoading());
    yield put(
      showErrorMessage({ error: err, title: "Alert" })
    );
  }
}

export function* watchcallBuyUpdateVehicleListPermit() {
  yield takeEvery(GET_UPDATE_BUY_PERMIT_VEHICLE_LIST, callBuyUpdateVehicleListPermit);
}

// Resume Buy Permit Order Payment
export function* callResumeBuyPermitOrderPayment(action) {
  try {
    yield put(startLoading());
    const store = yield select();
    const customerName = store.homeState?.customerName;
    const orderId = action?.payload;

    const res = yield call(callApi, {
      method: Method.GET,
      url: `/orders/${orderId}/pay`,
    });

    const { order, redirectDetails } = res.data;
    yield call(handleExternalRedirect, order, redirectDetails, customerName);
  } catch (err) {
    yield put(
      showErrorMessage({ error: err, title: "Resume Buy Permit Order Payment" })
    );
  } finally {
    yield put(stopLoading());
  }
}

export function* watchCallResumeBuyPermitOrderPayment() {
  yield takeEvery(RESUME_BUY_PERMIT_ORDER_PAYMENT, callResumeBuyPermitOrderPayment);
}

export function* handleExternalRedirect(order, redirectDetails, customerName) {
  const { url, parameters } = redirectDetails;
  const confirmationUrl = RouteService.permitPaymentStatus(customerName);

  const fullParameters = {
    ...parameters,
    signOutUrl: `${process.env.REACT_APP_PROXY_HOST}${confirmationUrl}`,
    incompleteSignOutUrl: `${process.env.REACT_APP_PROXY_HOST}${RouteService.incompletePayment(customerName)}`,
  };

  const searchParams = new URLSearchParams();
  Object.keys(fullParameters).forEach((key) => {
    searchParams.append(key, fullParameters[key]);
  });

  yield put(setBuyPermitOrderPayment(order));
  yield put(getBuyPermitGetPermitNumber(order.id));

  window.location.href = `${url}?${searchParams.toString()}`;
}



